import Vue from 'vue'
import Router from 'vue-router'

const VagasUltimas = () => import('@/components/vagas/Vagas_Ultimas')
const VagasDetalhe = () => import('@/components/vagas/Vagas_Detalhe')
const VagasAreas = () => import('@/components/vagas/Vagas_Areas')
const CurriculoMain = () => import('@/components/curriculo/Curriculo_Main')
const Curriculo = () => import('@/components/curriculo/Curriculo')
const CurriculoTrocaSenha = () => import('@/components/curriculo/Curriculo_TrocaSenha')
const VagasEncaminhadas = () => import('@/components/vagas/Vagas_Encaminhadas')
const CurriculoTokenCpf = () => import('@/components/curriculo/Curriculo_TokenCpf')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/vagas_detalhe/:api_key?/:vaga_id?',
      name: 'vagas_detalhe',
      component: VagasDetalhe,
    },
    {
      path: '/:api_key?',
      name: 'vagas_ultimas',
      component: VagasUltimas
    },
    {
      path: '/vagas_areas/edit/:nome',
      name: 'vagas_area',
      component: VagasAreas
    },
    {
      path: '/curriculo/troca_senha',
      name: 'curriculo_troca_senha',
      component: CurriculoTrocaSenha
    },
    {
      path: '/curriculo/curriculo',
      name: 'curriculo',
      component: Curriculo
    },
    {
      path: '/curriculo/main/:api_key?',
      name: 'curriculo_main',
      component: CurriculoMain
    },
    {
      path: '/curriculo/cpf_token',
      name: 'curriculo_cpf_token',
      component: CurriculoTokenCpf
    },
    {
      path: '/vagas_encaminhadas',
      name: 'vagas_encaminhadas',
      component: VagasEncaminhadas
    },
    {
      path: '*',
      name: 'default',
      component: VagasUltimas
    }
  ],
  mode: 'history'
})

